import React from 'react'
import { Row, Col, Card } from 'antd';

function FeaturedIn() {
    return (
        <>

            <section className='informationBanner mb-5'>
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2 className=''>Featured In</h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className='featured-area'>
                <div className='container'>
                    <Row gutter={16}>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.thehindu.com/brandhub/pr-release/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/article69046539.ece#:~:text=Delhi%2C%20Indi%20a%2C%2026th%20December%2C,departures%20to%%2020manage%20costs%20effectively." target='_blank'>
                                    <img src='https://www.thehindu.com/theme/images/th-online/thehindu-logo.svg' alt='the hindu' className='img-fluid mb-2 mt-1' />
                                    <p>The Hindu</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://aninews.in/news/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175623/" target='_blank'>
                                    <img src='https://upload.wikimedia.org/wikipedia/commons/c/c4/Ani-logo-black.png' alt='ANI' className='img-fluid mb-2 mt-1' />
                                    <p>ANI</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.business-standard.com/content/press-releases-ani/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices-124122600831_1.html" target='_blank'>
                                    <img src='https://bsmedia.business-standard.com/include/_mod/site/html5/images/business-standard-logo.png' alt='Business Standard' className='img-fluid mb-2 mt-1' />
                                    <p>Business Standard</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://theprint.in/ani-press-releases/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/2419800/" target='_blank'>
                                    <img src='https://upload.wikimedia.org/wikipedia/commons/2/2a/ThePrint_logo.png' alt='The Print' className='img-fluid mb-2 mt-1' />
                                    <p>The Print</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://m.dailyhunt.in/news/india/english/anienglish-epaper-anieng/superbworldtrip%2Bcomes%2Bwith%2Ba%2Bnew%2Bidentity%2Band%2Bunbeatable%2Bprices-newsid-n645024380?listname=newspaperLanding&index=35&topicIndex=0&mode=pwa&action=click" target='_blank'>
                                    <img src='https://m.dailyhunt.in/assets/img/desktop/logo.svg?mode=pwa&ver=4.0.196' alt='Daily Hunt' className='img-fluid mb-2 mt-1' />
                                    <p>Daily Hunt</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.latestly.com/agency-news/business-news-superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices-6519914.html" target='_blank'>
                                    <img src='https://stfe.latestly.com/images/logo.png' alt='Latestly' className='img-fluid mb-2 mt-1' />
                                    <p>Latestly</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.lokmattimes.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://d3pc1xvrcw35tl.cloudfront.net/lt/assets/images/lokmattimes-logo-v0.8.png' alt='Lokmat Times' className='img-fluid mb-2 mt-1' />
                                    <p>Lokmat Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.worldnewsnetwork.net/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/brand_logo.jpg' alt='World News Network' className='img-fluid mb-2 mt-1' />
                                    <p>World News Network</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.birminghamallnewsnetwork.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/birmingham_all_news_network.png' alt='Birmingham All News Network' className='img-fluid mb-2 mt-1' />
                                    <p>Birmingham All News Network</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.britishcolumbiatimes.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/British_Columbia_Times_nZMtEVb.png' alt='British Columbia Times' className='img-fluid mb-2 mt-1' />
                                    <p>British Columbia Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.britishnewsnetwork.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Britis_news_network.png' alt='British News Network' className='img-fluid mb-2 mt-1' />
                                    <p>British News Network</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.buffalodespatch.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Buffalo_Despatch.png' alt='Buffalo Despatch' className='img-fluid mb-2 mt-1' />
                                    <p>Buffalo Despatch</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.capitolhillreporter.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/capitol_hill.png' alt='Capitol Hill Reporter' className='img-fluid mb-2 mt-1' />
                                    <p>Capitol Hill Reporter</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.dubaicityreporter.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/rsz_2dubai_city_reporter.png' alt='Dubai City Reporter' className='img-fluid mb-2 mt-1' />
                                    <p>Dubai City Reporter</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.eastasiaallnewsportal.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/East_asia_all_news_portal_qbbwc3R.png' alt='East Asia All News Portal' className='img-fluid mb-2 mt-1' />
                                    <p>East Asia All News Portal</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.eastcoastamericannews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/east_coast_american_news.png' alt='East Coast America News' className='img-fluid mb-2 mt-1' />
                                    <p>East Coast America News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.englandnewsportal.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/england-news-portal.png' alt='England News Portal' className='img-fluid mb-2 mt-1' />
                                    <p>England News Portal</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.europeansuntimes.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/european_sun_star.png' alt='European Sun Times' className='img-fluid mb-2 mt-1' />
                                    <p>European Sun Times</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.federaldespatch.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/fedral_dispatch.png' alt='Federal Despatch' className='img-fluid mb-2 mt-1' />
                                    <p>Federal Despatch</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.floridabreakingnews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Florida_breaking_news.png' alt='Florida Breaking News' className='img-fluid mb-2 mt-1' />
                                    <p>Florida Breaking News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.francenetworktimes.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/france_network_times.png' alt='BuffaloDespatch' className='img-fluid mb-2 mt-1' />
                                    <p>France Network Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.londonchannelnews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/london_Channel_news.png' alt='London Channel News' className='img-fluid mb-2 mt-1' />
                                    <p>London Channel News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.losangeleseveningdespatch.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Los_Angeles_Evening_Despatch.png' alt='Los Angeles Evening Despatch' className='img-fluid mb-2 mt-1' />
                                    <p>Los Angeles Evening Despatch</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.maldivesstarplus.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/maldives_star_plus.png' alt='Maldives Star Plus' className='img-fluid mb-2 mt-1' />
                                    <p>Maldives Star Plus</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.miaminewsherald.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Miami_News_Herald.png' alt='Miami News Herald' className='img-fluid mb-2 mt-1' />
                                    <p>Miami News Herald</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.mountainviewsentinel.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/mountain_view_sentinel.png' alt='Mountain View Sentinel' className='img-fluid mb-2 mt-1' />
                                    <p>Mountain View Sentinel</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.newyorkdespatch.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/new-york-despatch.png' alt='New York Despatch' className='img-fluid mb-2 mt-1' />
                                    <p>New York Despatch</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.richmondeveningnews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/richmond-evening-news.png' alt='Richmond Evening News' className='img-fluid mb-2 mt-1' />
                                    <p>Richmond Evening News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.srilankaislandnews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Srilanka_island.png' alt='Srilanka Island News' className='img-fluid mb-2 mt-1' />
                                    <p>Srilanka Island News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.torontosuntimes.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Toronto_Sun_Times.png' alt='Toronto Sun Times' className='img-fluid mb-2 mt-1' />
                                    <p>Toronto Sun Times</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.usworldtoday.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/US_World_Today.png' alt='US World Today' className='img-fluid mb-2 mt-1' />
                                    <p>US World Today</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.washingtondcdespatch.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Washington_DC_Despatch.png' alt='Washington DC Despatch' className='img-fluid mb-2 mt-1' />
                                    <p>Washington DC Despatch</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.whitehousenewstime.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/white_house_news_times.png' alt='White House News Time' className='img-fluid mb-2 mt-1' />
                                    <p>White House News Time</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.indiannewsnetwork.net/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/INN_rVm3TwN.png' alt='Indian News Network' className='img-fluid mb-2 mt-1' />
                                    <p>Indian News Network</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.WestBengalKhabar.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/WB_samachar.png' alt='West Bengal Khabar' className='img-fluid mb-2 mt-1' />
                                    <p>West Bengal Khabar</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.VanakkamTamilnadu.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Vanakkam_TN.png' alt='Vanakkam Tamil Nadu' className='img-fluid mb-2 mt-1' />
                                    <p>Vanakkam Tamil Nadu</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.UPtoday.news/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/UP-today.png' alt='UP Today' className='img-fluid mb-2 mt-1' />
                                    <p>UP Today</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.Telanganajournal.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/telengana_journal.png' alt='Telangana Journal' className='img-fluid mb-2 mt-1' />
                                    <p>Telangana Journal</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.SouthIndiaNews.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/South_India_news.png' alt='South India News' className='img-fluid mb-2 mt-1' />
                                    <p>South India News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.punjablive.news/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/punjab-live.png' alt='Punjab Live' className='img-fluid mb-2 mt-1' />
                                    <p>Punjab Live</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.OdishaPost.news/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Odish_Post.png' alt='Odisha post' className='img-fluid mb-2 mt-1' />
                                    <p>Odisha post</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.NorthEastTimes.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/northeast_times.png' alt='North East Times' className='img-fluid mb-2 mt-1' />
                                    <p>North East Times</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.MaharashtraSamachar.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/maharashtra_news.png' alt='Maharashtra Samachar' className='img-fluid mb-2 mt-1' />
                                    <p>Maharashtra Samachar</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.MadhyaPradeshChronicle.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/MP-Chronicle.png' alt='Madhya Pradesh Chronicle' className='img-fluid mb-2 mt-1' />
                                    <p>Madhya Pradesh Chronicle</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.KashmirNewsline.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Kashmir_Newsline.png' alt='Kashmir News Line' className='img-fluid mb-2 mt-1' />
                                    <p>Kashmir News Line</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.KashmirBreakingNews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Kashmir_Breaking_News.png' alt='Kashmir Breaking News' className='img-fluid mb-2 mt-1' />
                                    <p>Kashmir Breaking News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.KarnatakaLive.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/karnataka_live.png' alt='Karnataka Live' className='img-fluid mb-2 mt-1' />
                                    <p>Karnataka Live</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.JharkhandTimes.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Jharkhand_Times.png' alt='Jharkhand Times' className='img-fluid mb-2 mt-1' />
                                    <p>Jharkhand Times</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.IndianEconomicObserver.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/IEO.png' alt='Indian Economic Observer' className='img-fluid mb-2 mt-1' />
                                    <p>Indian Economic Observer</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.HimachalPatrika.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Himanchal-Patrika.png' alt='Himachal Patrika' className='img-fluid mb-2 mt-1' />
                                    <p>Himachal Patrika</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.HaryanaToday.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Haryana_Today.png' alt='Haryana Today' className='img-fluid mb-2 mt-1' />
                                    <p>Haryana Today</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.GujaratVarta.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/gujrat-varta.png' alt='Gujarat Varta' className='img-fluid mb-2 mt-1' />
                                    <p>Gujarat Varta</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.GujaratSamachar.news/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/gujrat_samachar.png' alt='Gujarat Samachar' className='img-fluid mb-2 mt-1' />
                                    <p>Gujarat Samachar</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.DelhiLiveNews.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/DLN.png' alt='Delhi Live News' className='img-fluid mb-2 mt-1' />
                                    <p>Delhi Live News</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.ChhattisgarhToday.in/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Chatisgarh_Today.png' alt='Chhattisgarh Today' className='img-fluid mb-2 mt-1' />
                                    <p>Chhattisgarh Today</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.BiharTimes.news/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Bihar_Times.png' alt='Bihar Times' className='img-fluid mb-2 mt-1' />
                                    <p>Bihar Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.Bihar24x7.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/Bihar-24x7.png' alt='Bihar 24x7' className='img-fluid mb-2 mt-1' />
                                    <p>Bihar 24x7</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.AndhraPradeshMirror.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://aniportalimages.s3.amazonaws.com/media/details/AP_Mirror.png' alt='Andhra Pradesh Mirror' className='img-fluid mb-2 mt-1' />
                                    <p>Andhra Pradesh Mirror</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.kolkatanews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/kolkata-news.png' alt='Kolkata News' className='img-fluid mb-2 mt-1' />
                                    <p>Kolkata News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.kualalumpurnews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/kuala-lumpur-news.png' alt='Kuala Lumpur News' className='img-fluid mb-2 mt-1' />
                                    <p>Kuala Lumpur News</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.mumbainews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/mumbai-news.png' alt='Mumbai News' className='img-fluid mb-2 mt-1' />
                                    <p>Mumbai News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.srilankaislandnews.com/news/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices20241226175619/" target='_blank'>
                                    <img src='https://worldnewsn.s3.amazonaws.com/media/images/Srilanka_island.png' alt='Srilanka News' className='img-fluid mb-2 mt-1' />
                                    <p>Srilanka News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.bignewsnetwork.com/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.bignewsnetwork.com/bnn2/images/big-news-network.png' alt='Big News Network' className='img-fluid mb-2 mt-1' />
                                    <p>Big News Network</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.nepalnational.com/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/pr_logos/nepal-national.png' alt='Nepal National' className='img-fluid mb-2 mt-1' />
                                    <p>Nepal National</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.southeastasiapost.com/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/pr_logos/south-east-asia-post.png' alt='South East Asia Post' className='img-fluid mb-2 mt-1' />
                                    <p>South East Asia Post</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.bangkoknews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/bangkok-news.png' alt='Bangkok News' className='img-fluid mb-2 mt-1' />
                                    <p>Bangkok News</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}

                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.bruneinews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/brunei-news.png' alt='Brunei News' className='img-fluid mb-2 mt-1' />
                                    <p>Brunei News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.thecambodianews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/the-cambodia-news.png' alt='The Cambodia News' className='img-fluid mb-2 mt-1' />
                                    <p>The Cambodia News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.newdelhinews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/new-delhi-news.png' alt='New Delhi News' className='img-fluid mb-2 mt-1' />
                                    <p>New Delhi News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.cambodiantimes.com/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/pr_logos/cambodian-times.png' alt='Cambodian Times' className='img-fluid mb-2 mt-1' />
                                    <p>Cambodian Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.bangladeshsun.com/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/pr_logos/bangladesh-sun.png' alt='Bangladesh Sun' className='img-fluid mb-2 mt-1' />
                                    <p>Bangladesh Sun</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.laosnews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/laos-news.png' alt='Laos News' className='img-fluid mb-2 mt-1' />
                                    <p>Laos News</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.nepalnews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/nepal-news.png' alt='Nepal News' className='img-fluid mb-2 mt-1' />
                                    <p>Nepal News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.pakistannews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/pakistan-news.png' alt='Pakistan News' className='img-fluid mb-2 mt-1' />
                                    <p>Pakistan News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.indiasnews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src="https://static.midwestradionetwork.com/nn_logos/india's-news.png" alt='India News' className='img-fluid mb-2 mt-1' />
                                    <p>India News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.malaysianews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/malaysia-news.png' alt='Malaysian News' className='img-fluid mb-2 mt-1' />
                                    <p>Malaysian News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.indonesianews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/indonesia-news.png' alt='Indonesian News' className='img-fluid mb-2 mt-1' />
                                    <p>Indonesian News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.srilankannews.net/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/nn_logos/sri-lankan-news.png' alt='Srilankan News' className='img-fluid mb-2 mt-1' />
                                    <p>Srilankan News</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://www.heraldglobe.com/news/274887576/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://static.midwestradionetwork.com/pr_logos/herald-globe.png' alt='Herald Globe' className='img-fluid mb-2 mt-1' />
                                    <p>Herald Globe</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://up18news.com/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://i0.wp.com/up18news.com/wp-content/uploads/2023/04/1657947002596.png?w=412&ssl=1' alt='UP18 News' className='img-fluid mb-2 mt-1' />
                                    <p>UP18 News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://news9network.com/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://news9network.com/wp-content/uploads/2023/06/cropped-cropped-cropped-NEWS-1-1.png' alt='News9 Network' className='img-fluid mb-2 mt-1' />
                                    <p>News9 Network</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://kbktimes.com/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                <h2 className='mb-2 mt-1'>KBK Times</h2>
                                    <p>KBK Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://india-press-release.com/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://india-press-release.com/wp-content/uploads/2018/04/ipr-logo-1.png' alt='India Press Release' className='img-fluid mb-2 mt-1' />
                                    <p>India Press Release</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://prevalentindia.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://prevalentindia.in/wp-content/uploads/2023/04/cropped-Prevalent-India.png' alt='Prevalent India' className='img-fluid mb-2 mt-1' />
                                    <p>Prevalent India</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://lucnkowdigital.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://lucnkowdigital.com/wp-content/uploads/2025/11/lucknowdigital.png' alt='Lucknow Digital' className='img-fluid mb-2 mt-1' />
                                    <p>Lucknow Digital</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://rajasthanjournal.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://rajasthanjournal.com/wp-content/uploads/2025/11/rajasthanjournal.png' alt='Rajasthan Journal' className='img-fluid mb-2 mt-1' />
                                    <p>Rajasthan Journal</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://maharashtra24x7.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://maharashtra24x7.com/wp-content/uploads/2025/10/maharashtra24x7.png' alt='Maharashtra 24x7' className='img-fluid mb-2 mt-1' />
                                    <p>Maharashtra 24x7</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://up-patrika.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://up-patrika.com/wp-content/uploads/2025/11/uppatrika.png' alt='UP Patrika' className='img-fluid mb-2 mt-1' />
                                    <p>UP Patrika</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://madhyapradeshmirror.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://madhyapradeshmirror.com/wp-content/uploads/2025/11/madhyapradeshmirror-.png' alt='Madhya Pradesh Mirror' className='img-fluid mb-2 mt-1' />
                                    <p>Madhya Pradesh Mirror</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://khammaghanirajasthan.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://khammaghanirajasthan.com/wp-content/uploads/2025/11/khammaghanirajasthan.png' alt='Khamma Ghani Rajasthan' className='img-fluid mb-2 mt-1' />
                                    <p>Khamma Ghani Rajasthan</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://kanpurlive.in/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://kanpurlive.in/wp-content/uploads/2025/11/kanuprlive.png' alt='Kanpur Live' className='img-fluid mb-2 mt-1' />
                                    <p>Kanpur Live</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://livejabalpur.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://livejabalpur.com/wp-content/uploads/2024/07/logo.png' alt='Live Jabalpur' className='img-fluid mb-2 mt-1' />
                                    <p>Live Jabalpur</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://allahabadpost.in/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://allahabadpost.in/wp-content/uploads/2025/11/cropped-allahabadpost.png' alt='Allahabad Post' className='img-fluid mb-2 mt-1' />
                                    <p>Allahabad Post</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://rajasthanmirror.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://rajasthanmirror.com/wp-content/uploads/2025/11/rajasthanmirror.png' alt='Rajasthan Mirror' className='img-fluid mb-2 mt-1' />
                                    <p>Rajasthan Mirror</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://northwestnewstimes.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://northwestnewstimes.com/wp-content/uploads/2024/01/northwestnews22.png' alt='North West News Times' className='img-fluid mb-2 mt-1' />
                                    <p>North West News Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://mpnewsline.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://mpnewsline.com/wp-content/uploads/2025/11/mpnewsline.png' alt='MP Newsline' className='img-fluid mb-2 mt-1' />
                                    <p>MP Newsline</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://delhinewsnow.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://delhinewsnow.com/wp-content/uploads/2025/11/delhinewsnow.png' alt='Delhi News Now' className='img-fluid mb-2 mt-1' />
                                    <p>Delhi News Now</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://delhimorningtribune.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://delhimorningtribune.com/wp-content/uploads/2025/11/delhimorningtribune.png' alt='Delhi Morning Tribune' className='img-fluid mb-2 mt-1' />
                                    <p>Delhi Morning Tribune</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://theeveningpost.in/index.php/2024/12/26/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='' alt='The Evening Post' className='img-fluid mb-2 mt-1' />
                                    <p>The Evening Post</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://bhopalsuntimes.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://bhopalsuntimes.com/wp-content/uploads/2025/11/bhopalsuntimes.png' alt='Bhopal Sun Times' className='img-fluid mb-2 mt-1' />
                                    <p>Bhopal Sun Times</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://mpguardian.com/index.php/2024/12/26/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://mpguardian.com/wp-content/uploads/2025/11/cropped-mpguardian.png' alt='MP Guardian' className='img-fluid mb-2 mt-1' />
                                    <p>MP Guardian</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://udaipurdispatch.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://udaipurdispatch.com/wp-content/uploads/2023/06/udaipurdispatch.png' alt='Udaipur Dispatch' className='img-fluid mb-2 mt-1' />
                                    <p>Udaipur Dispatch</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://jodhpurreporter.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://jodhpurreporter.com/wp-content/uploads/2023/06/jodhpur-.png' alt='Jodhpur Reporter' className='img-fluid mb-2 mt-1' />
                                    <p>Jodhpur Reporter</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://nashik24.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://nashik24.com/wp-content/uploads/2023/11/nashik24-2048x663-white.jpeg' alt='Nashik 24' className='img-fluid mb-2 mt-1' />
                                    <p>Nashik 24</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://bizzsight.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://bizzsight.com/wp-content/uploads/2023/06/bizzsight-.png' alt='Bizz Sight' className='img-fluid mb-2 mt-1' />
                                    <p>Bizz Sight</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://nationalinsight.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://nationalinsight.in/wp-content/uploads/2025/04/nationalinsight.png' alt='National Insight' className='img-fluid mb-2 mt-1' />
                                    <p>National Insight</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://pinkcitynow.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://pinkcitynow.com/wp-content/uploads/2023/06/pinkcitynow.png' alt='Pink City Now' className='img-fluid mb-2 mt-1' />
                                    <p>Pink City Now</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://deccanexpress.co.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://deccanexpress.co.in/wp-content/uploads/2024/01/DECCAN-PNG.png' alt='Deccan Express' className='img-fluid mb-2 mt-1' />
                                    <p>Deccan Express</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://marudharchronicle.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://marudharchronicle.com/wp-content/uploads/2023/06/marudhar.png' alt='Marudhar Chronicle' className='img-fluid mb-2 mt-1' />
                                    <p>Marudhar Chronicle</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://khabarerajasthan.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://khabarerajasthan.com/wp-content/uploads/2023/06/khabrerajasthan.png' alt='Khabare Rajasthan' className='img-fluid mb-2 mt-1' />
                                    <p>Khabare Rajasthan</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://yourbangalore.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://yourbangalore.com/wp-content/uploads/2025/11/yourbanglore.png' alt='Your Bangalore' className='img-fluid mb-2 mt-1' />
                                    <p>Your Bangalore</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://holamumbai.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://holamumbai.com/wp-content/uploads/2025/11/holamumbai-.png' alt='Hola Mumbai' className='img-fluid mb-2 mt-1' />
                                    <p>Hola Mumbai</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://prakharjagaran.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://prakharjagaran.com/wp-content/uploads/2023/06/prakharjagran.png' alt='Prakhar Jagaran' className='img-fluid mb-2 mt-1' />
                                    <p>Prakhar Jagaran</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://sattaexpress.co.in/index.php/2024/12/26/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://sattaexpress.co.in/wp-content/uploads/2023/04/sattaexpress.png' alt='Satta Express' className='img-fluid mb-2 mt-1' />
                                    <p>Satta Express</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://businesspoint.co.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://businesspoint.co.in/wp-content/uploads/2025/04/businesspoint.jpg' alt='Business Point' className='img-fluid mb-2 mt-1' />
                                    <p>Business Point</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://nagpurnewstoday.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://nagpurnewstoday.com/wp-content/uploads/2023/04/nagpurnewstoday.png' alt='Nagpur News Today' className='img-fluid mb-2 mt-1' />
                                    <p>Nagpur News Today</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://delhinewswatch.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://delhinewswatch.com/wp-content/uploads/2023/04/delhinewswatch.png' alt='Delhi News Watch' className='img-fluid mb-2 mt-1' />
                                    <p>Delhi News Watch</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://indorepioneer.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://indorepioneer.com/wp-content/uploads/2025/04/indorepioneer.png.webp' alt='Indore Pioneer' className='img-fluid mb-2 mt-1' />
                                    <p>Indore Pioneer</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://gwaliorbuzz.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://gwaliorbuzz.com/wp-content/uploads/2023/06/gwaliorbuzz-.png' alt='Gwalior Buzz' className='img-fluid mb-2 mt-1' />
                                    <p>Gwalior Buzz</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://newstrackbhopal.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://newstrackbhopal.com/wp-content/uploads/2023/04/newstrackbhopal.png' alt='News Track Bhopal' className='img-fluid mb-2 mt-1' />
                                    <p>News Track Bhopal</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://madhyapradeshherald.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://madhyapradeshherald.com/wp-content/uploads/2025/11/madhyapradeshherald.png' alt='Madhya Pradesh Herald' className='img-fluid mb-2 mt-1' />
                                    <p>Madhya Pradesh Herald</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://shekhawatisamachar.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://shekhawatisamachar.com/wp-content/uploads/2023/04/shekhawatisamachar.png' alt='Shekhawati Samachar' className='img-fluid mb-2 mt-1' />
                                    <p>Shekhawati Samachar</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://ncr-chronicle.com/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://ncr-chronicle.com/wp-content/uploads/2023/06/ncrchronicle.png' alt='NCR Chronicle' className='img-fluid mb-2 mt-1' />
                                    <p>NCR Chronicle</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://risingentrepreneurs.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://risingentrepreneurs.in/wp-content/uploads/2023/04/risingentrepreneurs.png' alt='Rising Entrepreneur' className='img-fluid mb-2 mt-1' />
                                    <p>Rising Entrepreneur</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://newsdaddy.co.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://newsdaddy.co.in/wp-content/uploads/2023/04/newsdaddy.png.webp' alt='News Daddy' className='img-fluid mb-2 mt-1' />
                                    <p>News Daddy</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://mint-money.in/index.php/2024/12/26/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://mint-money.in/wp-content/uploads/2025/04/mintmoney.png.webp' alt='Mint Money' className='img-fluid mb-2 mt-1' />
                                    <p>Mint Money</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://rajasthanexpress.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://rajasthanexpress.in/wp-content/uploads/2023/04/rajasthanexpress.png' alt='Rajasthan Express' className='img-fluid mb-2 mt-1' />
                                    <p>Rajasthan Express</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://thecapitalnews.in/index.php/2024/12/26/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices/" target='_blank'>
                                    <img src='https://thecapitalnews.in/wp-content/uploads/2025/04/thecapitalnews-.png' alt='The Capital News' className='img-fluid mb-2 mt-1' />
                                    <p>The Capital News</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://thedeccanmessenger.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://thedeccanmessenger.com/wp-content/uploads/2023/04/thedeccanmessenger.png' alt='The Deccan Messenger' className='img-fluid mb-2 mt-1' />
                                    <p>The Deccan Messenger</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://theindianinfluencer.com/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://theindianinfluencer.com/wp-content/uploads/2025/04/indianinfluencer.png' alt='The Indian Influencer' className='img-fluid mb-2 mt-1' />
                                    <p>The Indian Influencer</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://thedailymetro.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://thedailymetro.in/wp-content/uploads/2023/04/thedailymetro.png' alt='The Daily Metro' className='img-fluid mb-2 mt-1' />
                                    <p>The Daily Metro</p>
                                </a>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://centralherald.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://centralherald.in/wp-content/uploads/2025/04/centralherald.png.webp' alt='Central Herald' className='img-fluid mb-2 mt-1' />
                                    <p>Central Herald</p>
                                </a>
                            </Card>
                        </Col>

                        {/* //////////////////////////////////////////////////// */}
                        
                        <Col md={4}>
                            <Card className='text-center'>
                                <a href="https://livemumbai.in/index.php/business/superbworldtrip-comes-with-a-new-identity-and-unbeatable-prices" target='_blank'>
                                    <img src='https://livemumbai.in/wp-content/uploads/2023/06/livemumbai.png' alt='Live Mumbai' className='img-fluid mb-2 mt-1' />
                                    <p>Live Mumbai</p>
                                </a>
                            </Card>
                        </Col>

                    </Row>
                </div>
            </section>

        </>
    )
}

export default FeaturedIn